
import { FormattedDate } from 'react-intl';

/**
 * Calendar date view
 */
export const calendarDateView = (date: Date) => {
  return <span><i className="fa fa-calendar me-2"/><FormattedDate value={date}/></span>;
}

/**
 * Deadline is on next month for the period
 */
export const getDeadline = (date: Date) => {
  const newDate = new Date(date);
  newDate.setDate(25);
  newDate.setMonth(date.getMonth() + 1);
  return newDate;
}

export const getPreviousMonthStr = (d: Date) => {
  let month = d.getMonth().toString();
  month = d.getMonth() < 10 ? '0' + month : month;
  if (month === '00')
  {
    month = '12';
  }
  return month;
}

const getPreviousMonth = (date: Date) => {
  date.setMonth(date.getMonth() - 1);
  return date;
}

export const getMonthStr = (d: Date) => {
  let month = (d.getMonth()+1).toString();
  month = (d.getMonth()+1) < 10 ? '0' + month : month;
  return month;
}

export const getCurrentPeriodString = () => {
  let date = new Date();
  let prevDate = getPreviousMonth(date);
  let prevMonthStr = getMonthStr(date);
  return prevDate.getFullYear() + "-" + prevMonthStr;
}

export const getPreviousPeriodString = () => {
  let date = new Date();
  let prevDate = getPreviousMonth(getPreviousMonth(date));
  let prevMonthStr = getMonthStr(prevDate);
  return prevDate.getFullYear() + "-" + prevMonthStr;
}

export const getPeriodString = (date: Date) => {
  return date.getFullYear() + "-" + getMonthStr(date);
}

export const getStartOfYearPeriodString = () => {
  let date = getPreviousMonth(new Date());
  return date.getFullYear() + "-01";
}

export const getPeriodDate = (period: string) => {
  if (period) {
    let splitted = period.split("-");
    let date;
    if (splitted.length > 2) {
      date = new Date(period);
    } else {
      let yearStr = parseInt(splitted[0]);
      let monthStr = parseInt(splitted[1]);
      date = new Date(yearStr, monthStr - 1);
    }
    return date;
  }
}

export const formatFinNumber = (val: any, digits = 2) => {
  // Return value with two decimals and comma as a separator
  return Number(val).toLocaleString("fi-FI", { maximumFractionDigits: digits, minimumFractionDigits: digits });
}

export const formatFinCurrency = (val: number) => {
  // Return value with two decimals and comma as a separator
  return Number(val).toLocaleString("fi-FI", { style: 'currency', currency: 'EUR' });
}